import API from '../..';
const ENTITY = 'layouts';

export const getLayouts = (offerId) => API.get(`/api/v1/${ENTITY}/${offerId}/`);
